// extracted by mini-css-extract-plugin
export default {"text-button":"TextButton_text-button__uycpA"};